console.log('js/referral-share.js -> v0.1.0');
(() => {
	document.addEventListener('click', function(event) {
		if (event.target.classList.contains('share__link')) {
			saveShareLink(event.target);
		}
		if (event.target.classList.contains('share__item')) {
			createShareLink(event.target);
		}
		if (event.target.classList.contains('copy-static-link')) {
			copyStaticLinkShare(event.target);
		}
		if (event.target.classList.contains('copy-link')) {
			copyLinkShare();
		}
	});

	function generateUrlHash(length) {
		var str = "";

		for (var i=0; i < length; i++) {
		  var rand = Math.floor( Math.random() * 62 );
		  var charCode = rand+= rand > 9 ? (rand < 36 ? 55 : 61) : 48;
		  str += String.fromCharCode( charCode );
		}

		return str;
	}

	function createShortURL(hash) {
		let url = window.location.origin + '/sharing/';
		return url + hash;
	}

	function createURL(linkData) {
		const hash = linkData.hash
		const shareURL = {
			'url_short': createShortURL(hash),
			'hash': hash
		};

		return shareURL;
	}

	function createLink (string) {
		var el = document.createElement('a');
		el.setAttribute('href', string);
		el.style = {position: 'absolute', left: '-9999px'}
		document.body.appendChild(el);
		el.click();
	}

	function saveShareLink(target) {
		const hash = document.querySelector('#sharing-hash').value;
		let position = '';
		if(target.classList.contains('social-button')) {
			position = target.closest('.listing-share-container').dataset.position
		}

		marketing.trackSoftGoals(marketing.SoftGoals.Referral, target.dataset.shareType);

		const linkData = {
			'type': target.dataset.shareType,
			'text': target.dataset.shareText || "",
			'twitterhandle': target.dataset.twitterHandle || "",
			'hashtags': target.dataset.twitterHashtags || "",
			'condition': target.dataset.shareCondition || "",
			'source': 'referral',
			'lid': document.querySelector('.share-container').dataset.lid,
			'oid': document.querySelector('.share-container').dataset.oid,
			'campaign': document.querySelector('.share-container').dataset.campaign,
			'short-title': document.querySelector('.share-container').dataset.urlShard.replace(/ /g,"-"),
			'title': document.querySelector('#sharing-listing-name').value,
			'position': position,
			'hash': hash
		};

		if(target.classList.contains('referral-share')) {
			linkData.url = createURL(linkData);
		}

		if(!target.classList.contains('social-button') && !target.classList.contains('referral-share')) {
			isLoading(target.querySelector('.icon'));
		}
		const payload = {
			'type': linkData.type,
			'source': linkData.campaign,
			'listing_id': Number(linkData.lid),
			'inquiry_id': null,
			'position': linkData.position
		}

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(payload),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}

		fetch(`/sharing/${hash}`, params)
		.then(function(response) {
			return response.json();
		})
		.then(function(response) {
			if (response.status == "ok") {
				if(target.classList.contains("referral-share")) {
					switch (linkData.type) {
						case "facebook":
							shareToFacebook(linkData);
							break;
						case "twitter":
							shareToTwitter(linkData);
							break;
						case "whatsapp":
							shareToWhatsApp(linkData);
							break;
						case "email":
							shareToEmail(linkData);
							break;
						case "copy-link":
							getShareLink(linkData);
							break;
					};
				}
				else {
					switch (linkData.type) {
						case "copy-link":
							getStaticLinkShare(target);
							break;
						default:
							break;

					};
				}
			}
			if(!target.classList.contains('social-button') && !target.classList.contains('referral-share')) {
				isDoneLoading(target.querySelector('.icon'));
			}
		})
		.catch(function(error) {
			if(!target.classList.contains('social-button') && !target.classList.contains('referral-share')) {
				isDoneLoading(target.querySelector('.icon'));
			}
			console.error('Broken:', error);
		});
	}

	function createShareLink(target) {
		const linkData = {
			'type': target.dataset.shareType,
			'text': target.dataset.shareText || "",
			'twitterhandle': target.dataset.twitterHandle || "",
			'hashtags': target.dataset.twitterHashtags || "",
			'condition': target.dataset.shareCondition || "",
			'source': 'referral',
			'lid': document.querySelector('.share-container').dataset.lid,
			'oid': document.querySelector('.share-container').dataset.oid,
			'campaign': document.querySelector('.share-container').dataset.campaign,
			'short-title': document.querySelector('.share-container').dataset.urlShard.replace(/ /g,"-"),
			'title': document.querySelector('#sharing-listing-name').value
		};

		isLoading(target.querySelector('.icon'));

		linkData.url = createURL(linkData, true);

		const payload = {
			'type': linkData.type,
			'source': linkData.campaign,
			'listing_id': Number(linkData.lid),
			'inquiry_id': null
		}

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(payload),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}

		fetch(`/sharing/${linkData.url.hash}`, params)
		.then(function(response) {
			return response.json();
		})
		.then(function(response) {
			if (response.status == "ok") {
				switch (linkData.type) {
					case "facebook":
						shareToFacebook(linkData);
						break;
					case "twitter":
						shareToTwitter(linkData);
						break;
					case "whatsapp":
						shareToWhatsApp(linkData);
						break;
					case "messenger":
						shareToMessenger(linkData);
						break;
					case "email":
						shareToEmail(linkData);
						break;
					case "copy-link":
						getLinkShare(linkData);
						break;
					case "copy-static-link":
						getStaticLinkShare();
						break;

				};
			}
			isDoneLoading(target.querySelector('.icon'));
		})
		.catch(function(error) {
			isDoneLoading(target.querySelector('.icon'));
			console.error('Broken:', error);
		});
	}

	function shareToFacebook(data) {
		FB.ui({
			display: 'popup',
			method: 'stream.share',
			size: {width: 800, height: 500},
			href: data.url,
		});
	}

	function shareToTwitter(data) {
		const windowConfig = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600';
		if (data.condition == "post-stay"){
			window.open(`https://twitter.com/intent/tweet?url=${data.url.url_short}&text=${data.text}&via=${data.twitterhandle}&hashtags=${data.hashtags}`, '', windowConfig);
		} else {
			window.open(`https://twitter.com/intent/tweet?url=${data.url.url_short}/${data['short-title']}&text=${data.text}&via=${data.twitterhandle}&hashtags=${data.hashtags}`, '', windowConfig);
		}
		return false;
	}

	function shareToWhatsApp(data) {
		let link = 'https://api.whatsapp.com/send';
		if (data.condition == "post-stay"){
			link += `?text=${data.text} ${data.url.url_short}`;
		} else {
			link += `?text=${data.text} ${data.url.url_short}/${data['short-title']}`;
		}
		window.open(link);
		return false;
	}

	function shareToMessenger(data) {
		let link = `${data.url.url_short}`;
		if (data.condition != "post-stay"){
			link += `/${data['short-title']}`;
		}
		window.open('fb-messenger://share?link=' + encodeURIComponent(link));
	}

	function shareToEmail(data) {
		let link = 'mailto:';
		if (data.condition == "post-stay"){
			link += `?subject=${data.title}&body=${data.text}%0A%0A${data.url.url_short}`;
		} else {
			link += `?subject=${data.title}&body=${data.text}%0A%0A${data.url.url_short}/${data['short-title']}`;
		}
		createLink(link);
	}

	function getLinkShare(data) {
		let url = data.url.url_short;
		if (data.condition != "post-stay"){
			url += '/' + data['short-title'];
		}
		const wrapper = document.querySelector('.referral-share-link-wrapper');
		const field = document.querySelector('.generated-link');

		field.value = url;
		wrapper.classList.add('active');
		field.select();
		field.focus();
	}

	function getStaticLinkShare(target) {
		let wrapper, field;
		if(!target.classList.contains('social-button')) {
			wrapper = document.querySelector('.referral-share-link-wrapper');
			field = document.querySelector('.generated-link');
		}
		else {
			wrapper = target.closest('.listing-share-container').querySelector('.referral-share-link-wrapper');
			field = target.closest('.listing-share-container').querySelector('.generated-link');
		}
		wrapper.classList.add('active');
		field.select();
		field.focus();

		if (window.innerWidth < 768) {
			setTimeout(() => field.scrollIntoView({ behavior: 'smooth', block: 'center' }), 50);
		}
	}

	function copyLinkShare() {
		const field = document.querySelector('.generated-link');
		field.select();
		document.execCommand('copy');
		toast.info(translations.linkCopiedToClipboard, {icon: 'ebs-icon-check-rounded-stroked', delay: 2500}, toast.fade);
	}

	function copyStaticLinkShare(target) {
		let field;
		if(!target.classList.contains('social-button-copy')) {
			field = document.querySelector('.generated-link');
		}
		else {
			field = target.closest('.listing-share-container').querySelector('.generated-link');
		}
		field.select();
		document.execCommand('copy');
		toast.info(translations.linkCopiedToClipboard, {icon: 'ebs-icon-check-rounded-stroked', delay: 2500}, toast.fade);
	}

	function isLoading(element) {
		element.classList.add('is-loading');
	}

	function isDoneLoading(element) {
		element.classList.remove('is-loading');
	}

	function getShareLink(data) {
		let url = data.url.url_short;
		if (data.condition != "post-stay"){
			url += '/' + data['short-title'];
		}
		const linkInput = document.querySelector('.referral-share-copy-input-field');
		linkInput.value = url;
		document.querySelector('.referral-share-copy-input').classList.remove('hidden');
		document.querySelector('.referral-share-copy').classList.add('hidden');
		linkInput.select();
		linkInput.focus();
	}
})();

const shareListing = (() => {
	document.addEventListener('click', (event) => {
		if (event.target.classList.contains('shares')) {
			gae('referral','referral_share_gallery_button');
			modals.create('Share listing', shareListing.modalBody());
		}

		if (event.target.classList.contains('referral-share-copy-input-suffix')) {
			const shareLink = document.querySelector('.referral-share-copy-input-field');
			shareLink.select()
			document.execCommand('copy');
			toast.info(translations.linkCopiedToClipboard, {icon: 'ebs-icon-check-rounded-stroked', delay: 2500}, toast.fade);
		}
	});

	document.addEventListener('touchend', (event) => {
		if (event.target.classList.contains('referral-share-copy-input-suffix')) {
			const shareLink = document.querySelector('.referral-share-copy-input-field');
			shareLink.select()
			document.execCommand('copy');
			toast.info(translations.linkCopiedToClipboard, {icon: 'ebs-icon-check-rounded-stroked', delay: 2500}, toast.fade);
		}
	});

	return {
		modalBody: () => {
			return `
			<div class="referral-share-listing-gallery">
				<div class="row">
					<div class="col-sm-5 referral-share-square referral-share referral-share-facebook share__link" data-share-type="facebook">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#3677E9" class="referral-share referral-share-facebook" viewBox="0 0 16 16">
							<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
						</svg>
						<span class="referral-share referral-share-title referral-share-facebook">Facebook</span>
					</div>
					<div class="col-sm-5 referral-share-square referral-share referral-share-twitter share__link" data-share-type="twitter">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#56AFDE" class="referral-share referral-share-twitter" viewBox="0 0 16 16">
							<path class="referral-share referral-share-twitter" d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
						</svg>
						<span class="referral-share referral-share-title referral-share-twitter">Twitter</span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-5 referral-share-square referral-share referral-share-whatsapp share__link" data-share-type="whatsapp">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#65CE71" class="referral-share referral-share-whatsapp" viewBox="0 0 16 16">
							<path class="referral-share referral-share-whatsapp" d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
						</svg>
						<span class="referral-share-title referral-share-whatsapp">Whatsapp</span>
					</div>
					<div class="col-sm-5 referral-share-square referral-share referral-share-email share__link" data-share-type="email">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#022444" class=" referral-share referral-share-email" viewBox="0 0 16 16">
							<path class="referral-share referral-share-email" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
						</svg>
						<span class="referral-share-email referral-share-title">Email</span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-11 referral-share-copy-row referral-share-square referral-share referral-share-copy share__link" data-share-type="copy-link">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#022444" class="referral-share referral-share-copy" viewBox="0 0 16 16">
							<path class="referral-share referral-share-copy" d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
						</svg>
						<span class="referral-share-title referral-share referral-share-copy">Copy</span>
					</div>
					<div class="col-sm-11 referral-share-copy-row referral-share referral-share-copy-input hidden">
						<input type="text" class="referral-share-copy-input-field form-control">
						<span class="referral-share referral-share-copy-input-suffix">Copy link</span>
					</div>
				</div>
			<div>`;
		},
	}
})();
  